module.exports = __webpack_public_path__ + "static/media/tail.5413bcfc.svg";